export const SPINNER_QUANTITY = {
  MAX: 250,
  MIN: 1
};

export const STATUS = {
  AVAILABLE: "available",
  UNAVAILABLE: "unavailable",
  CANNOTBEDELIVERED: "cannotBeDelivered"
};

export const PRODUCT_MODALTYPE = "LIQUID";
